import addProjectButtonDirective from './add-project-button.directive';

const addProjectButtonModule = angular.module('addProjectButton', [
])
  .directive('addProjectButton', addProjectButtonDirective)
  .name;

export default addProjectButtonModule;
